import React from "react";

interface TeamMemberProps {
  name: string;
  image: string;
  title?: string;
  credentials?: string[];
  email?: string;
}

const TeamMember: React.FC<TeamMemberProps> = ({
  name,
  image,
  title,
  credentials,
  email,
}) => {
  return (
    <div className="relative mb-20">
      <img src={image} alt={name} className="w-full mb-5 shadow-sm" />
      <div className="space-y-1.5">
        <h3 className="text-lg font-semibold text-gray-800">{name}</h3>
        {title && <p className="text-sm text-gray-600">{title}</p>}
        {credentials && credentials.length > 0 && (
          <div className="text-xs text-gray-600 leading-relaxed mt-2">
            {credentials.map((credential, idx) => (
              <p key={idx} className="mb-1">
                {credential}
              </p>
            ))}
          </div>
        )}
        {email && <p className="text-xs text-gray-600 mt-2">{email}</p>}
      </div>
      <div className="absolute -bottom-6 right-0">
        <span className="inline-block w-16 h-0.5 bg-gray-300"></span>
      </div>
    </div>
  );
};

const Team: React.FC = () => {
  const teamMembers = [
    {
      name: "Dr. Alfonso Montes Camelo",
      image:
        "/images/nuestro-equipo/WhatsApp+Image+2024-03-20+at+5.51.57+PM.jpeg",
      title: "Abogado Senior",
      credentials: [
        "Director del Departamento de Derecho Penal de la Universidad Libre seccional Cartagena",
        "Abogado Penalista, Máster en Derecho y Ciencias Penales",
      ],
      email: "alfonsomontes@live.com",
    },
    {
      name: "Dr. Oswaldo Enrique Ortiz Colón",
      image:
        "/images/nuestro-equipo/WhatsApp+Image+2024-03-20+at+5.51.59+PM.jpeg",
      title: "Abogado Senior",
      credentials: [
        "Director del Departamento de Derecho Público de la Universidad Libre seccional Cartagena. Abogado Constitucionalista, Máster en Derecho y Ciencias Penales",
      ],
      email: "oswaldo.ortiz@ula.edu.co",
    },
    {
      name: "Andrés Felipe Soto Barrios",
      image:
        "/images/nuestro-equipo/WhatsApp+Image+2024-03-20+at+5.51.58+PM-2.jpeg",

      title: "Socio Fundador | Abogado & Consultor",
      credentials: [],
      email: "",
    },
    {
      name: "Elina Marcela Meriño Ortega",
      image:
        "/images/nuestro-equipo/WhatsApp+Image+2024-03-20+at+5.55.13+PM.jpeg",
      title: "Socia Fundadora | Especialista en Administración & Gerencia",
      credentials: [],
      email: "",
    },
  ];

  return (
    <div className="relative">
      {/* Hero section with law background */}
      <div
        className="relative bg-cover bg-center py-24"
        style={{
          backgroundImage: "url('/images/nuestro-equipo/law+1+banner (3).png')",
        }}
      >
        <div className="absolute inset-0 bg-gray-800 bg-opacity-60"></div>
        <div className="relative z-10 text-center">
          <h1 className="text-4xl font-bold text-white tracking-wider uppercase">
            NUESTRO EQUIPO
          </h1>
        </div>
      </div>

      {/* White curved separator */}
      <div
        className="h-20 bg-white relative -mt-8"
        style={{
          borderTopLeftRadius: "100% 70%",
          borderTopRightRadius: "100% 70%",
        }}
      ></div>

      {/* Team grid */}
      <div className="bg-white pb-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-24 gap-y-8">
            <div className="flex justify-end md:pr-6">
              <div className="w-full max-w-md">
                <TeamMember
                  name={teamMembers[0].name}
                  image={teamMembers[0].image}
                  title={teamMembers[0].title}
                  credentials={teamMembers[0].credentials}
                  email={teamMembers[0].email}
                />
              </div>
            </div>
            <div className="md:pl-6">
              <div className="w-full max-w-md">
                <TeamMember
                  name={teamMembers[1].name}
                  image={teamMembers[1].image}
                  title={teamMembers[1].title}
                  credentials={teamMembers[1].credentials}
                  email={teamMembers[1].email}
                />
              </div>
            </div>
            <div className="flex justify-end md:pr-6">
              <div className="w-full max-w-md">
                <TeamMember
                  name={teamMembers[2].name}
                  image={teamMembers[2].image}
                  title={teamMembers[2].title}
                  credentials={teamMembers[2].credentials}
                  email={teamMembers[2].email}
                />
              </div>
            </div>
            <div className="md:pl-6">
              <div className="w-full max-w-md">
                <TeamMember
                  name={teamMembers[3].name}
                  image={teamMembers[3].image}
                  title={teamMembers[3].title}
                  credentials={teamMembers[3].credentials}
                  email={teamMembers[3].email}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
